(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.mobile-nav').forEach((details) => {
    const summary = details.querySelector('summary');

    details.addEventListener('toggle', () => {
      if (!details.open) return;
      const firstLink = details.querySelector('.mobile-nav__panel a');
      if (firstLink) firstLink.focus();
    });

    details.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !details.open) return;
      details.open = false;
      summary.focus();
    });

    document.addEventListener('click', (event) => {
      if (!details.open || details.contains(event.target)) return;
      details.open = false;
      summary.focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart-quantity-input]').forEach((input) => {
    input.addEventListener('change', () => {
      if (input.form) {
        input.form.submit();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
